import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(3),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      minHeight: 375
    },
    container: {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column'
    },
    selected: {},
    notSelected: {},
    searchField: {
      marginBottom: theme.spacing(1)
    },
    businessUnitItem: {
      padding: theme.spacing(0.5),
      borderRadius: '4px',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.02)'
      }
    }
  });
});
